import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

export default function StatefulSets() {
  return (
    <PagedWorkloadPage
      title="StatefulSets" kind="StatefulSet" resource="statefulsets" label="statefulsets"
      deletable restartable
      cols={['Name', 'Namespace', 'Ready', 'Age']}
      renderRow={s => [
        <td key="n"><Code>{s.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{s.namespace}</td>,
        <td key="r" style={{
          color: s.ready_replicas === s.replicas ? 'var(--color-success-500)' : 'var(--color-danger-500)',
          fontWeight: 600,
        }}>{s.ready_replicas}/{s.replicas}</td>,
        <td key="a"><Age ts={s.created_at} /></td>,
      ]}
    />
  );
}
